import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'rxnt-progress-timeout',
  templateUrl: './rxnt-progress-timeout.component.html',
  styleUrl: './rxnt-progress-timeout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RxntProgressTimeoutComponent implements OnInit, OnChanges {
  @Input() show: boolean = false;
  @Input() durationMs: number = 5000;

  animationDuration: string = '';
  initialized: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['durationMs'] && this.initialized) {
      this.setAnimationDuration(this.durationMs);
    }
  }

  ngOnInit(): void {
    this.setAnimationDuration(this.durationMs);
    this.initialized = true;
  }

  private setAnimationDuration(durationMs: number): void {
    const durationSeconds: number = durationMs / 1000;
    this.animationDuration = `${ durationSeconds }s`;
  }
}
